export default __webpack_public_path__ + "static/media/Photo_fw14_056.79956555.png";